import { ComparisonLayout } from "../models/models"

export function isColumnsOnly(layout: ComparisonLayout): boolean {
  switch (layout) {
    case ComparisonLayout.VerticalThreeWaySplit:
      return true
    default:
      return false
  }
}

export function isVertical(layout: ComparisonLayout): boolean {
  switch (layout) {
    case ComparisonLayout.Vertical:
    case ComparisonLayout.VerticalLeftSplit:
    case ComparisonLayout.VerticalRightSplit:
    case ComparisonLayout.VerticalThreeWaySplit:
      return true
    default:
      return false
  }
}

export function isReverse(layout: ComparisonLayout): boolean {
  switch (layout) {
    case ComparisonLayout.HorizontalTopSplit:
    case ComparisonLayout.VerticalLeftSplit:
      return true
    default:
      return false
  }
}
